
import { Component, Vue } from 'vue-property-decorator';
import PersonalDetailsEditor from '@/app/components/settings/individual/PersonalDetailsEditor.vue';
import ProfilePhotoEditor from '@/app/components/settings/individual/ProfilePhotoEditor.vue';
import FileUploadCounter from 'ah-common-lib/src/common/components/upload/FileUploadCounter.vue';
import DocumentsUploader from '@/app/components/settings/client/DocumentsUploader.vue';
import { ClientFileCategories, UploadedFile } from 'ah-api-gateways';
import { useAuthStore } from '@/app/store/authModule';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';

@Component({
  components: {
    PersonalDetailsEditor,
    ProfilePhotoEditor,
    FileUploadCounter,
    DocumentsUploader,
  },
})
export default class PersonalSettingsView extends Vue {
  private files: UploadedFile[] = [];

  get authStore() {
    return useAuthStore();
  }

  get individualSettingsStore() {
    return useIndividualSettingsStore();
  }

  get companyFileCategories() {
    return [ClientFileCategories.PROOF_OF_ADDRESS, ClientFileCategories.PROOF_OF_FUNDS, ClientFileCategories.PHOTO_ID];
  }

  get numberOfFiles() {
    return this.files.filter((file) => this.companyFileCategories.includes(file.category as ClientFileCategories))
      .length;
  }

  get isClientUser() {
    return this.authStore.isClientUser;
  }

  get isIndividualClientUser() {
    return this.individualSettingsStore.client && !this.authStore.isAgent && !this.authStore.isCompanyClient;
  }

  get client() {
    return this.individualSettingsStore.client;
  }
}
